import * as React from "react";

import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { ActiveTaskAction } from "../ActiveTaskAction";

import { ChaseImmunisationBloodTestResultModal } from "./ChaseImmunisationBloodTestResultModal";

export const ChaseImmunisationBloodTestResultButton: React.FunctionComponent<{ task: TaskModel }> = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <ActiveTaskAction task={props.task}>
            <Button content="Chase result" floated="right" onClick={openModal} />
            {modalOpen && <ChaseImmunisationBloodTestResultModal task={props.task} onClose={closeModal} />}
        </ActiveTaskAction>
    );
};
